module.exports = __webpack_public_path__ + "static/media/ic_lactancia_pin.b68378ad.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/ic_lactancia_pin.webp
// module id = 203
// module chunks = 1